import { render, staticRenderFns } from "./fastvaluedeal-money-back-guarantee.vue?vue&type=template&id=7355fb2e&scoped=true&"
import script from "./fastvaluedeal-money-back-guarantee.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-money-back-guarantee.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-money-back-guarantee.vue?vue&type=style&index=0&id=7355fb2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7355fb2e",
  null
  
)

export default component.exports